import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class IncomeForTransfusion extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);

		this.state = {

			start_folio: '',
			end_folio: '',
			
			listado:[],
			columns:[
				{title:'No. Consecutivo', width:'150px'},
				{title:'Centro de Origen', width:'180px'},
				{title:'Fecha/Hora de Ingreso', width:'200px'},
				{title:'Nombre Donador', width:'220px'},
				{title:'No. Origen', width:'120px'},
				{title:'Componente', width:'180px'},
				{title:'No. Componente', width:'150px'},
				{title:'G&RH', width:'100px'},
				{title:'Fecha/Hora Caducidad', width:'180px'},
				{title:'Destino', width:'100px'},
				{title:'Fecha/Hora Baja', width:'100px'},
				{title:'Folio de Baja', width:'180px'},
				{title:'Motivo de Baja', width:'180px'},
				{title:'No. Petición', width:'180px'},
				{title:'Nombre Paciente', width:'180px'},
				{title:'Centro Peticionario', width:'180px'},
				{title:'Servicio solicitante', width:'180px'},
				{title:'Doctor que solicita', width:'180px'},
				{title:'Diagnóstico', width:'250px'},
				{title:'Folio Envío', width:'150px'},
				{title:'Fecha/Hora Envío', width:'150px'},
			],
			filename:"Ingresos y Egresos ST",
			totales:"",
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){		

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del Folio: " + this.state.start_folio + " Al: " + this.state.end_folio; 
		
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	orientation:'landscape',
					pageSize:'LEGAL',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
					
						//doc.content[3].table.widths=["10%","15%","8%","15%","8%","15%","10%","9%","10%"];
                	
                		doc.styles.tableHeader.fontSize = 5.5;
                		doc.defaultStyle.fontSize = 5.5; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

		console.log(this.state)
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}
	}

	searching(){
		if(this.isValidForm()){
			var obj = {
				start_folio:this.state.start_folio,
				end_folio:this.state.end_folio,
				health_facilities_id: sessionStorage.getItem('health_facilities_id')
			};
			
			this.props.waiting.handleShow('Buscando...');
			fetch(Config.default.apiGateway.URL+'reports/income_and_expenses',{
				method: 'POST',
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){						
					var list = [];
					
					response.forEach((res, i)=>{
						list.push([
							res.unit_relabel_number,								
							res.origin_center,
							moment(res.entry_date).format('DD/MM/YYYY HH:mm'),
							res.donor_name,
							res.origin_number,
							res.component_name,
							res.component_number,
							res.group_rh,
							moment(res.expiration_date).format('DD/MM/YYYY HH:mm'),
							res.exit_type,
							res.discard_date !== null ? moment(res.discard_date).format('DD/MM/YYYY HH:mm') : "",
							res.discard_folio !== null ? res.discard_folio : "",
							res.discard_reason !== null ? res.discard_reason : "",
							res.petition_number !== null ? res.petition_number : "",
							res.patient_name !== null ? res.patient_name : "",
							res.petition_center !== null ? res.petition_center : "",
							res.petition_service !== null ? res.petition_service : "",
							res.petition_doctor !== null ? res.petition_doctor : "",
							res.petition_diagnosis !== null ? res.petition_diagnosis : "",
							res.delivered_folio !== null ? res.delivered_folio : "",
							res.delivered_date !== null ? moment(res.delivered_date).format('DD/MM/YYYY HH:mm') : "",
							
						])
					})

					setTimeout(()=>{
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
						this.$el.DataTable().destroy();
						this.$el.empty();
					}, 500);

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);

					this.setState({
						listado: list,
						//totales:response.Count
					});
					
				}
			});
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Distribución ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_distribution"} 
		            submenu={"help_income_and_expenses"}
				/>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Folio Desde</span>
									<input type="text" className="form-control" name="start_folio" id="start_folio" maxLength={20}
										value={this.state.start_folio} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Folio Hasta</span>
									<input type="text" className="form-control" name="end_folio" id="end_folio" maxLength={20}
										value={this.state.end_folio} onChange={this.handleChange} required />
								</div>

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del Folio:  {this.state.start_folio}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al:  {this.state.end_folio}    
									</span>
								</div>

								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"expenses-discards"} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (IncomeForTransfusion);